import { styled } from '@mui/material/styles'

export const ActionGroupLabel = styled('div')({
  fontSize: '12px',
  lineHeight: '18px',
  color: 'rgba(0, 0, 0, 0.26)',
  display: 'block',
  textAlign: 'center',
  whiteSpace: 'nowrap',
})

export const ActionGroupLink = styled('a')({
  fontSize: '12px !important',
  lineHeight: '18px',
  color: '#5f6972',
  display: 'block',
  textAlign: 'center',
})

export const AccountIconPlaceholderDiv = styled('div')(({ theme }) => ({
  display: 'inline-block',
  width: '20px',
  height: '20px',
  borderRadius: '4px',
  backgroundColor: '#d8d8d8',
  verticalAlign: 'middle',
  margin: `${theme.spacing(-0.2)} 0 0 ${theme.spacing(0.4)}`,
}))

export const AccountInfo = styled('div')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.text.primary,
  lineHeight: '20px',
}))

export const Actions = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  height: '36px',
  flexBasis: '3',
  fontSize: '14px',
  lineHeight: '36px',
  minWidth: '205px',
  textAlign: 'right',
  width: '215px',
})

export const ActionsLabel = styled('label')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.text.primary,
}))

export const CalendarButtonLink = styled('a')(({ theme }) => ({
  cursor: 'pointer',
  marginLeft: theme.spacing(-0.6),
  padding: theme.spacing(0.6),
  borderRadius: '4px',
  transition: 'all 0.25s ease',
  '::hover': {
    backgroundColor: '#ebebeb',
  },
}))

export const CalendarIconImg = styled('img')(({ theme }) => ({
  marginLeft: theme.spacing(0.6),
  marginBottom: theme.spacing(0.2),
  verticalAlign: 'middle',
}))

export const FooterLink = styled('a')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexFlow: 'row no-wrap',

  fontSize: '14px',
  color: theme.palette.text.primary,
  lineHeight: '40px',
  margin: `0 ${theme.spacing(-1.6)}`,
  padding: `0 ${theme.spacing(1.6)}`,
  cursor: 'pointer',
  transition: 'all 0.25s',

  '::hover': {
    backgroundColor: '#f7f7f7',
  },
}))

export const HorizontalLine = styled('hr')(({ theme }) => ({
  border: '0',
  height: '1px',
  background: '#ddd',
  margin: `0 ${theme.spacing(-1.6)}`,
}))
export const NextAction = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  flexBasis: '1',
  minWidth: '80px',
  width: '200px',
})

export const NextActionDate = styled('div')(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.text.primary,
}))

export const NextActionLabel = styled('label')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: 'Source Sans Pro Semibold',
  fontSize: '14px',
  lineHeight: '22px',
  margin: '0',
}))
export const ParentBody = styled('div')({
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: 'space-between',
  minHeight: '110px',
})

export const ParentHeader = styled('div')({
  minHeight: '36px',
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
})
